'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AppAuthData$PharmacyUser$Impersonating(admin, userId) {
  this.Lapp_data_AppAuthData$PharmacyUser$Impersonating__f_admin = null;
  this.Lapp_data_AppAuthData$PharmacyUser$Impersonating__f_userId = null;
  this.Lapp_data_AppAuthData$PharmacyUser$Impersonating__f_admin = admin;
  this.Lapp_data_AppAuthData$PharmacyUser$Impersonating__f_userId = userId;
}
export { $c_Lapp_data_AppAuthData$PharmacyUser$Impersonating as $c_Lapp_data_AppAuthData$PharmacyUser$Impersonating };
$c_Lapp_data_AppAuthData$PharmacyUser$Impersonating.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AppAuthData$PharmacyUser$Impersonating.prototype.constructor = $c_Lapp_data_AppAuthData$PharmacyUser$Impersonating;
/** @constructor */
function $h_Lapp_data_AppAuthData$PharmacyUser$Impersonating() {
}
export { $h_Lapp_data_AppAuthData$PharmacyUser$Impersonating as $h_Lapp_data_AppAuthData$PharmacyUser$Impersonating };
$h_Lapp_data_AppAuthData$PharmacyUser$Impersonating.prototype = $c_Lapp_data_AppAuthData$PharmacyUser$Impersonating.prototype;
$c_Lapp_data_AppAuthData$PharmacyUser$Impersonating.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_data_AppAuthData$PharmacyUser$Impersonating.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1902162089, true);
});
$c_Lapp_data_AppAuthData$PharmacyUser$Impersonating.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppAuthData$PharmacyUser$Impersonating)) {
    var x = this.Lapp_data_AppAuthData$PharmacyUser$Impersonating__f_admin;
    var x$2 = x$0.Lapp_data_AppAuthData$PharmacyUser$Impersonating__f_admin;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lapp_data_AppAuthData$PharmacyUser$Impersonating__f_userId;
      var x$4 = x$0.Lapp_data_AppAuthData$PharmacyUser$Impersonating__f_userId;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lapp_data_AppAuthData$PharmacyUser$Impersonating.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_data_AppAuthData$PharmacyUser$Impersonating.prototype.productArity__I = (function() {
  return 2;
});
$c_Lapp_data_AppAuthData$PharmacyUser$Impersonating.prototype.productPrefix__T = (function() {
  return "Impersonating";
});
$c_Lapp_data_AppAuthData$PharmacyUser$Impersonating.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_data_AppAuthData$PharmacyUser$Impersonating__f_admin;
  }
  if ((n === 1)) {
    return this.Lapp_data_AppAuthData$PharmacyUser$Impersonating__f_userId;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_AppAuthData$PharmacyUser$Impersonating.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "admin";
  }
  if ((n === 1)) {
    return "userId";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_AppAuthData$PharmacyUser$Impersonating.prototype.admin__Lapp_data_AppAuthData$AdminUser = (function() {
  return this.Lapp_data_AppAuthData$PharmacyUser$Impersonating__f_admin;
});
function $isArrayOf_Lapp_data_AppAuthData$PharmacyUser$Impersonating(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_AppAuthData$PharmacyUser$Impersonating)));
}
export { $isArrayOf_Lapp_data_AppAuthData$PharmacyUser$Impersonating as $isArrayOf_Lapp_data_AppAuthData$PharmacyUser$Impersonating };
var $d_Lapp_data_AppAuthData$PharmacyUser$Impersonating = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AppAuthData$PharmacyUser$Impersonating, "app.data.AppAuthData$PharmacyUser$Impersonating", ({
  Lapp_data_AppAuthData$PharmacyUser$Impersonating: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lapp_data_AppAuthData: 1,
  Lapp_data_AppAuthData$PharmacyUser: 1,
  Lapp_data_AppAuthData$Impersonating: 1
}));
export { $d_Lapp_data_AppAuthData$PharmacyUser$Impersonating as $d_Lapp_data_AppAuthData$PharmacyUser$Impersonating };
//# sourceMappingURL=app.data.-App-Auth-Data$-Pharmacy-User$-Impersonating.js.map
